<template>
  <BaseImage
    v-bind="$attrs"
    v-on="$listeners"
    :styleConfig="styleConfig"
  />
</template>

<script>
  import BaseImage from '@base/v2/base-image'
  import { Layout } from '@js/styles'

  export default {
    name: 'ImagePrimary',
    inheritAttrs: false,
    components: {
      BaseImage,
    },
    props: {
      disableCursor: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    data: function () {
      return {
        styleConfig: {
          container: {
            height: '100%',
            width: '100%',
          },
          image: {},
          link: {},
          root: {},
        },
      };
    },
    created: function () {
      Object.assign(
        this.styleConfig.image,
        {
          ...(this.disableCursor
            ? {}
            : {
              cursor: {
                '': 'pointer',
                disabled: 'default',
              },
            }
          ),
        },
      );
    },
  };
</script>
